export default "__VITE_ASSET__BSsqf_Of__"